import {
    Navigate,
    Link,
} from 'react-router-dom';
import {
    Button,
    Card,
    Container,
    Stack,
    Text,
    Title,
} from '@mantine/core';
import {
    IndexPageLayout,
    PlatformLoader,
    SimplePageContentWrapper,
} from '@flexinet/ui-components';
import {IndexPageNavigation} from '../navigation/IndexPageNavigation';
import {useEffect} from 'react';
import {useOrganizations} from '../hooks/useOrganizations';
import {useUserAccount} from '../../../../hooks/useUserAccount';
import {AiOutlinePlus, AiOutlineTeam} from 'react-icons/ai';

export const IndexPage = () => {

    const {userAccount} = useUserAccount();

    if (!userAccount) {
        throw new Error('user account is required parameter');
    }

    const {
        items: organizations,
        loading,
        fetchRecords,
    } = useOrganizations();

    useEffect(() => {
        fetchRecords({
            adminAccountId: userAccount.id as string,
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const accountOrganization = organizations.length > 0 ? organizations[0] : null;

    if (accountOrganization) {
        return (<Navigate to={`/organizations/${accountOrganization.id}`}/>);
    }

    if (loading) {
        return (
            <IndexPageLayout title="Organizations" tools={[]} pageNavigation={<IndexPageNavigation/>}>
                <SimplePageContentWrapper>
                    <PlatformLoader message="Loading organizations..."/>
                </SimplePageContentWrapper>
            </IndexPageLayout>
        );
    }

    return (
        <IndexPageLayout title="Organizations" tools={[]} pageNavigation={<IndexPageNavigation/>}>
            <SimplePageContentWrapper>
                <Container size="sm">
                    <Card shadow="sm" padding="xl" radius="md" withBorder>
                        <Stack align="center" gap="lg" py="xl">
                            <AiOutlineTeam size={48} color="var(--mantine-color-dimmed)"/>
                            <Stack align="center" gap="xs">
                                <Title order={3}>No Organization Yet</Title>
                                <Text c="dimmed" size="sm" ta="center" maw={400}>
                                    Create an organization to manage team members,
                                    share resources, and collaborate across your platform.
                                </Text>
                            </Stack>
                            <Button
                                component={Link}
                                to="/organizations/add"
                                leftSection={<AiOutlinePlus size={16}/>}
                                size="md"
                            >
                                Create Organization
                            </Button>
                        </Stack>
                    </Card>
                </Container>
            </SimplePageContentWrapper>
        </IndexPageLayout>
    );
};
